import { render, staticRenderFns } from "./PrehledPracProTiskCarKodu.vue?vue&type=template&id=6b4ef032&"
import script from "./PrehledPracProTiskCarKodu.vue?vue&type=script&lang=ts&"
export * from "./PrehledPracProTiskCarKodu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports